// extracted by mini-css-extract-plugin
export var circle = "ProgressNav_circle__qHsrb";
export var large = "ProgressNav_large__59INx";
export var navigation = "ProgressNav_navigation__abS6S";
export var node = "ProgressNav_node__swjl2";
export var selected = "ProgressNav_selected__YTixF";
export var title = "ProgressNav_title__Z4l2g";